export default {
  name: "KilaKilaButton"
};